import React from 'react';
import PropTypes from 'prop-types';

export const VisibilityOff = ({ width, height, ...props }) => (
  <svg
    data-icon='visibility-off'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m16.1 13.3-1.45-1.45c.15-.783-.075-1.517-.675-2.2-.6-.683-1.375-.95-2.325-.8L10.2 7.4c.283-.133.57-.233.863-.3.291-.067.604-.1.937-.1 1.25 0 2.313.438 3.188 1.313.874.874 1.312 1.937 1.312 3.187 0 .333-.033.646-.1.938-.067.291-.167.579-.3.862Zm3.2 3.15-1.45-1.4a10.951 10.951 0 0 0 1.688-1.588A8.898 8.898 0 0 0 20.8 11.5c-.833-1.683-2.03-3.02-3.588-4.013C15.654 6.497 13.917 6 12 6c-.483 0-.958.033-1.425.1a9.625 9.625 0 0 0-1.375.3L7.65 4.85A11.081 11.081 0 0 1 12 4c2.517 0 4.758.696 6.725 2.088C20.692 7.479 22.117 9.283 23 11.5a11.696 11.696 0 0 1-1.512 2.738A11.007 11.007 0 0 1 19.3 16.45Zm.5 6.15-4.2-4.15c-.583.183-1.17.32-1.762.413-.592.091-1.205.137-1.838.137-2.517 0-4.758-.696-6.725-2.087C3.308 15.52 1.883 13.717 1 11.5c.35-.883.792-1.704 1.325-2.463A11.514 11.514 0 0 1 4.15 7L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4ZM5.55 8.4a10.74 10.74 0 0 0-1.325 1.425A9.016 9.016 0 0 0 3.2 11.5c.833 1.683 2.03 3.02 3.587 4.012C8.346 16.505 10.083 17 12 17c.333 0 .658-.02.975-.063.317-.041.642-.087.975-.137l-.9-.95c-.183.05-.358.088-.525.113A3.539 3.539 0 0 1 12 16c-1.25 0-2.313-.438-3.188-1.313C7.939 13.813 7.5 12.75 7.5 11.5c0-.183.013-.358.037-.525.026-.167.063-.342.113-.525L5.55 8.4Z'
    />
  </svg>
);

VisibilityOff.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

VisibilityOff.defaultProps = {
  width: 24,
  height: 24,
};
